import React from 'react'
import { TextField as MuiTextField, TextFieldProps } from '@mui/material'
import './TextField.sass'

interface CustomTextFieldProps extends Omit<TextFieldProps, 'variant'> {
    variant?: 'outlined' | 'filled' | 'standard'
}

function CustomTextField({ 
    className = '', 
    sx = {}, 
    variant = 'outlined',
    ...props 
}: CustomTextFieldProps) {
    return (
        <MuiTextField
            {...props}
            variant={variant}
            className={`custom-text-field ${className}`}
            sx={sx}
        />
    )
}

export default CustomTextField
